/** @file IK timeline properties → the channel names animation.setKey takes for them. */
export const IK_CHANNELS: Readonly<Record<string, string>> = { mix: 'ikMix', softness: 'ikSoftness', bendPositive: 'ikBend', stretch: 'ikStretch', compress: 'ikCompress' };
